<template>
  <vs-popup class="holamundo validation-modal" :class="{'valid-validation-modal': !invalid}" :title="'Validation'" :active.sync="popupActive">
    <div style="margin-bottom: 20px;">
      <h3 style="margin-bottom: 10px;">Ar Readiness</h3>
      <div class="validation-el">
        <div class="validation-label">Academic reviewed:</div> <div :class="{'error': !asset.academic_reviewed, 'success': asset.academic_reviewed}">{{ asset.academic_reviewed ? 'Yes' : 'No' }}</div>
      </div>
      <div class="validation-el">
        <div class="validation-label">Artist reviewed:</div> <div :class="{'error': !asset.artist_reviewed, 'success': asset.artist_reviewed}">{{ asset.artist_reviewed ? 'Yes' : 'No' }}</div>
      </div>
      <div class="validation-el">
        <div class="validation-label">Visibility:</div> <div :class="{'error': !asset.visibility, 'success': asset.visibility}">{{ asset.visibility ? 'Valid' : 'Invalid' }}</div>
      </div>
      <div class="validation-el">
        <div class="validation-label">Starred variant:</div> <div :class="{'error': !asset.published_variant, 'success': asset.published_variant}">{{ asset.published_variant ? 'Valid' : 'Invalid' }}</div>
      </div>
    </div>
    <div>
      <div v-if="asset.asset_type === '3D'">
        <h3 style="margin-bottom: 10px;display: flex; align-items: flex-end;" class="validation-variant-header">
          <i class="star-icon material-icons" v-if="data.general.published_variant"> star </i>
          <i class="material-icons" v-if="!data.general.published_variant"> star_outline </i>
          Variation</h3>
        <div class="validation-label">Type 3D:</div><div>
        <div class="validation-sub-el">
          <div class="validation-label">Size:</div><div :class="{'error': !data.published_variation['3d'].size, 'success': data.published_variation['3d'].size}">{{ data.published_variation['3d'].size ? 'Valid' : 'Invalid(>5Mb)' }}</div>
        </div>
      </div>
      </div>
    </div>
    <div v-if="$store.state.user.role.name === 'Manager' && !invalid">
      <vs-button class="mr-2 shadow-lg" type="gradient" id="validation-save-btn" @click="save" style="margin-top: 20px">
        Save
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      default: () => {}
    },
    invalid: {
      type: Boolean,
      default: false
    },
    updateTranslations: Function,
    assetlibSize: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      popupActive: true,
      isAction: false,
    }
  },
  computed: {

  },
  mounted () {
    this.popupActive = true;
  },
  created () {

  },
  watch: {
    popupActive() {
      if (!this.popupActive) {
        this.closeModal();
      }
    }
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$emit('closeArReviewedValidaton', this.isAction);
      }, 1)
    },
    updateAsset() {
      const updateAssetData = (assetData, {onlyUpdateData = 'false'} = {}) => {
        return this.$axios({
          method: id ? 'put' : 'post',
          url: `${url}?onlyUpdateData=${onlyUpdateData}`,
          data: assetData
        })
      }

      let id = this.$route.params.id;
      let url = '/assets';
      if (id) {
        url += '/' + id;
      }
      let data = this.asset;
      let { meta_KG: assetMetakg } = data;
      delete data.meta_KG;

      let promises = [updateAssetData(data)];
      if (assetMetakg && assetMetakg.length) {
        promises.push(updateAssetData({meta_KG: assetMetakg}, {onlyUpdateData: "true"}))
      }
      return Promise.all(promises).catch((error) => {
        this.$root.removeLoading('#validation-save-btn')
        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed save asset'})
      })
    },
    syncAssetlib() {
      let pv = this.asset.variants.find(item => item._id === this.asset.published_variant);
      if (pv && pv.coobo_library_link) {
        let match = pv.coobo_library_link.match(/\/view_asset\/(\S+)$/);
        if (match && match[1]) {
          this.$axios({
            method: 'post',
            url: `https://preprodms.embibe.com/coobo_ms/sync-assetlib`,
            data: {ids: [match[1]]}
          }).catch((e) => {
            console.log(e);
          })
        }
      }
    },
    syncFullTranslations(ids) {
      return this.$axios({
        method: 'post',
        url: `/sync-full-translations`,
        data: {
          without_overwrite: 'true',
          ids: ids,
          returnData: 'true'
        }
      }).catch((e) => {
        console.log(e);
      })
    },
   save() {
     this.$root.addLoading('#validation-save-btn');
     this.updateAsset().then(() => {
       if (this.asset.published_variant) {
         if (this.$store.state.env !== 'development') {
           this.syncFullTranslations([this.asset._id]).then(res => {
             if (res && res.data && res.data.length) {
               this.syncAssetlib();

               let r = {
                 ar_reviewed: true
               }
               if (res.data && Array.isArray(res.data)) {
                 r.locales = res.data.pop();
               }
               this.updateTranslations(r)
             }
             this.$root.removeLoading('#validation-save-btn');
             this.popupActive = false;
           })
         } else {
           this.updateTranslations({
             ar_reviewed: true
           })
           this.$root.removeLoading('#validation-save-btn');
           this.popupActive = false;
         }
       } else {
         this.$root.removeLoading('#validation-save-btn');
       }
     })
    }
  }
}
</script>
